module.exports = __webpack_public_path__ + "img/bedroom-arch.07506709.webp";